var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"name",class:{'type-user': _vm.isUser}},[_c('div',{staticClass:"name-bar"},[_c('core-gamename',{staticClass:"name-link",attrs:{"game":_vm.item.game,"collection":_vm.item.collection}})],1),(_vm.version && _vm.isUser && _vm.isBase)?_c('div',{staticClass:"name-edition"},[_vm._v(_vm._s(_vm.version))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }